<template>
  <div class="module key-container small">
    <input class="small" v-model="keyInput" ref="key"
      type="text" placeholder="paste access key then press enter"
      maxlength="64" @keyup.enter="submitKey"
    />

    <div class="status">
      <div :class="messageClass + '-fg'" class="message">
        {{ message }}
      </div>
      <div class="auth-controls" :style="{opacity: controlsOpacity}">
        <span class="pointer" @click="logout">logout</span>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../EventBus.js';

export default {
  data () {
    return {
      keyInput: '',
      message: 'Waiting for key...',
      messageClass: 'info',
      get_ticket_timeout: null
    };
  },
  computed: {
    wsName () {
      return this.$store.state.ws_ticket.client;
    },
    wsNamespace () {
      return this.$store.state.ws_ticket.namespace;
    },
    keySummary () {
      return `${this.wsNamespace}/${this.wsName} (${this.$store.state.key.slice(0, 8)})`;
    },
    controlsOpacity () {
      return this.$store.state.ws_ticket.id ? 1 : 0;
    }
  },
  methods: {
    logout () {
      localStorage.clear();
      window.location = '/auth/logout';
    },
    submitKey () {
      this.$store.commit('SET_ACCESS_KEY', this.keyInput);
      this.$refs.key.disabled = true;
      this.message = 'loading...';
      this.tryGetTicket();
    },

    //
    // using key in store, try to get fresh websocket ticket
    //
    tryGetTicket () {
      const xreq = new XMLHttpRequest();
      xreq.responseType = 'json';
      xreq.open('POST', '/api/v1/ws-ticket');

      xreq.onerror = () => {
        this.message = 'connection error while fetching ticket';
        this.messageClass = 'error';
        this.$refs.key.disabled = false;

        // continuously retry
        clearTimeout(this.get_ticket_timeout);
        this.get_ticket_timeout = setTimeout(this.tryGetTicket, 5000);
      };

      xreq.onload = () => {
        if (xreq.status !== 200) {
          this.message = 'key not accepted, or server error';
          this.messageClass = 'error';
          this.$refs.key.disabled = false;

          // continuously retry
          clearTimeout(this.get_ticket_timeout);
          this.get_ticket_timeout = setTimeout(this.tryGetTicket, 8000);

          return;
        }

        clearTimeout(this.get_ticket_timeout);

        this.message = 'Key OK';
        this.messageClass = 'success';
        this.$refs.key.disabled = true;

        // key was good, so save to local storage
        localStorage.setItem('access_key', this.$store.state.key);

        // save ticket so WS component can connect
        this.$store.commit('SET_WS_TICKET', xreq.response);

        this.keyInput = this.keySummary;
      };

      xreq.setRequestHeader('X-Key', this.$store.state.key);
      xreq.send();
    }
  },
  created () {
    // check if key exists in local store
    const key = localStorage.getItem('access_key');

    if (key) {
      this.$store.commit('SET_ACCESS_KEY', key);
      this.tryGetTicket();
    }

    EventBus.$on('refresh ticket', () => {
      this.tryGetTicket();
    });
  },
  destroyed () {
    EventBus.$off('refresh ticket');
  }
};
</script>

<style lang="scss" scoped>
  input {
    width: 100%;
    margin: 0 auto;
    padding: 10px;
    font-family: 'Roboto Mono';
    border: 1px solid;
    border-color: #ddd;
  }

  input::placeholder {
    color: #777;
  }

  input:disabled {
    color: #ccc;
    background-color: white;
  }

  .key-container {
    position: relative;
  }

  .status {
    display: flex;
    flex-direction: row;
    margin-top: 10px;

    .auth-controls {
      width: 25%;
      text-align: right;
    }
    .message {
      width: 75%;
    }
  }
</style>
